/* Sunday Paw Club - Halloween bundle builder.
   One request adds every selected piece (/cart/add.js); when 2+ Halloween
   pieces are in, /discount/CODE is visited so the code is already on the
   checkout. Sizes follow the product page selection until the shopper
   changes one by hand. */
(function(){
  'use strict';
  if(window.__hbInit)return;
  window.__hbInit=true;

  var ORDER=['XXS','XS','S','M','L','XL','2XL','3XL'];
  function norm(s){s=String(s||'').toUpperCase().split(' ').join('');return s==='XXL'?'2XL':s==='XXXL'?'3XL':s;}
  function rank(s){var i=ORDER.indexOf(norm(s));return i<0?99:i;}

  function money(cents,fmt){
    fmt=fmt||'€{{amount_with_comma_separator}}';
    var v=(Number(cents)||0)/100;
    function fx(n,d,ts,ds){var p=n.toFixed(d).split('.'),i=p[0],o='';while(i.length>3){o=ts+i.slice(-3)+o;i=i.slice(0,-3);}o=i+o;return d?o+ds+p[1]:o;}
    return fmt.replace(/{{ *([a-z_]+) *}}/,function(_,k){
      switch(k){
        case 'amount_with_comma_separator':return fx(v,2,'.',',');
        case 'amount_no_decimals':return fx(v,0,',','.');
        case 'amount_no_decimals_with_comma_separator':return fx(v,0,'.',',');
        case 'amount_with_apostrophe_separator':return fx(v,2,"'",'.');
        case 'amount_with_space_separator':return fx(v,2,' ',',');
        default:return fx(v,2,',','.');
      }
    });
  }

  function init(root){
    var fmt=root.getAttribute('data-money');
    var code=root.getAttribute('data-code');
    var min=parseInt(root.getAttribute('data-min'),10)||2;
    var pct=parseInt(root.getAttribute('data-pct'),10)||10;
    var cartUrl=root.getAttribute('data-cart')||'/cart';
    var rootUrl=(root.getAttribute('data-root')||'/').replace(/[/]?$/,'/');
    var btn=root.querySelector('[data-hb-add]');
    var err=root.querySelector('[data-hb-err]');
    var busy=false;

    /* ----- items ----- */
    var items=[].slice.call(root.querySelectorAll('[data-hb-item]')).map(function(el){
      var sel=el.querySelector('[data-hb-variant]');
      if(sel&&sel.getAttribute('data-sort')==='size'){
        var keep=sel.value;
        var opts=[].slice.call(sel.options).filter(function(o){return o.value;});
        opts.sort(function(a,b){return rank(a.getAttribute('data-size'))-rank(b.getAttribute('data-size'));});
        opts.forEach(function(o){sel.appendChild(o);});
        sel.value=keep;
      }
      var it={
        el:el,sel:sel,chk:el.querySelector('[data-hb-check]'),
        hw:el.getAttribute('data-halloween')==='1',
        title:el.getAttribute('data-title'),
        priceOut:el.querySelector('[data-hb-price]'),
        touched:false,styleTouched:false,userToggled:false,
        key:el.getAttribute('data-key'),
        when:el.getAttribute('data-when'),
        follow:el.getAttribute('data-follow')==='1',
        pre:el.getAttribute('data-pre')==='1',
        id:function(){return sel?(sel.value?+sel.value:null):+el.getAttribute('data-variant');},
        price:function(){
          if(!sel)return +el.getAttribute('data-price');
          var o=sel.options[sel.selectedIndex];return o?+o.getAttribute('data-price'):0;
        },
        label:function(){
          if(!sel)return '';
          var o=sel.options[sel.selectedIndex];return o&&o.value?o.textContent.split('·')[0].trim():'';
        }
      };
      return it;
    });

    function setSize(it,size){
      if(!it.sel||it.sel.getAttribute('data-sort')!=='size'||!size)return false;
      var want=norm(size),hit=null;
      [].forEach.call(it.sel.options,function(o){if(!hit&&o.value&&!o.disabled&&norm(o.getAttribute('data-size'))===want)hit=o;});
      if(!hit)return false;
      it.sel.value=hit.value;
      return true;
    }

    /* Style variants (the hat & bandana set) are picked by name. */
    function setStyle(it,name){
      if(!it.sel||it.sel.getAttribute('data-sort')==='size')return;
      var want=name.toLowerCase(),hit=null;
      [].forEach.call(it.sel.options,function(o){if(!hit&&o.value&&!o.disabled&&o.textContent.trim().toLowerCase().indexOf(want)===0)hit=o;});
      if(hit)it.sel.value=hit.value;
    }
    function byKey(k){for(var i=0;i<items.length;i++){if(items[i].key===k)return items[i];}return null;}

    /* ----- anchor (product page) ----- */
    var anchor=null;
    var anchorEl=root.querySelector('[data-hb-anchor]');
    if(anchorEl){
      var list=[];
      try{list=JSON.parse(anchorEl.querySelector('script').textContent);}catch(e){list=[];}
      var byId={};list.forEach(function(v){byId[v.id]=v;});
      var idField=document.querySelector('[data-buy-form] [data-variant-id]');
      anchor={
        key:anchorEl.getAttribute('data-key'),
        hw:anchorEl.getAttribute('data-halloween')==='1',
        title:anchorEl.getAttribute('data-title'),
        v:function(){var id=idField?+idField.value:+anchorEl.getAttribute('data-variant');return byId[id]||null;},
        optOut:anchorEl.querySelector('[data-hb-anchor-opt]'),
        priceOut:anchorEl.querySelector('[data-hb-anchor-price]')
      };
      var syncAnchor=function(){
        var v=anchor.v();if(!v)return;
        if(anchor.optOut)anchor.optOut.textContent=v.title==='Default Title'?'':v.title;
        if(anchor.priceOut)anchor.priceOut.textContent=money(v.price,fmt);
        if(v.size)items.forEach(function(it){if(!it.touched)setSize(it,v.size);});
        render();
      };
      var form=document.querySelector('[data-buy-form]');
      if(form)form.addEventListener('change',function(){setTimeout(syncAnchor,0);});
      var first=anchor.v();
      if(first&&first.size)items.forEach(function(it){setSize(it,first.size);});
    }

    /* ----- size chips (homepage) ----- */
    var chips=[].slice.call(root.querySelectorAll('[data-hb-size]'));
    chips.forEach(function(c){
      c.addEventListener('click',function(){
        chips.forEach(function(x){x.classList.toggle('is-on',x===c);x.setAttribute('aria-pressed',x===c?'true':'false');});
        var s=c.getAttribute('data-hb-size');
        items.forEach(function(it){if(setSize(it,s))it.touched=false;});
        render();
      });
    });

    /* ----- state ----- */
    function lines(){
      var out=[];
      if(anchor){var v=anchor.v();if(v)out.push({id:v.id,price:v.price,hw:anchor.hw,title:anchor.title,opt:v.title==='Default Title'?'':v.title,anchor:true,available:v.available});}
      items.forEach(function(it){
        if(!it.chk.checked)return;
        out.push({id:it.id(),price:it.price(),hw:it.hw,title:it.title,opt:it.label(),item:it});
      });
      return out;
    }

    /* Matching rules, run before every render:
       - on the set's own page, show only the sweater in the colour of the
         chosen style (black bandana -> Midnight, anything orange -> Pumpkin);
       - where the set follows the sweaters, switch its style to match. */
    function applyRules(){
      if(anchor&&anchor.key==='set'){
        var v=anchor.v(),tone=v&&/black/i.test(v.title)?'black':'orange';
        items.forEach(function(it){
          if(!it.when)return;
          var show=it.when===tone;
          it.el.hidden=!show;
          if(!show)it.chk.checked=false;
          else if(!it.userToggled&&it.pre)it.chk.checked=true;
        });
      }
      items.forEach(function(it){
        if(it.key!=='set'||!it.follow||it.styleTouched)return;
        var mid=byKey('midnight'),pum=byKey('pumpkin');
        var m=mid&&mid.chk.checked,p=pum&&pum.chk.checked;
        if(p&&!m)setStyle(it,'Bat suit');
        else if(m)setStyle(it,'Black drool towel');
      });
    }

    function render(){
      applyRules();
      var ls=lines();
      var total=0,hwTotal=0,hwN=0;
      ls.forEach(function(l){total+=l.price;if(l.hw){hwTotal+=l.price;hwN++;}});
      var unlocked=hwN>=min;
      /* Shopify rounds the percentage down on each line, so do the same. */
      var save=0;
      if(unlocked)ls.forEach(function(l){if(l.hw)save+=Math.floor(l.price*pct/100);});

      items.forEach(function(it){
        it.el.classList.toggle('is-on',it.chk.checked);
        if(it.priceOut)it.priceOut.textContent=money(it.price(),fmt);
      });

      var ul=root.querySelector('[data-hb-lines]');
      if(ul){
        ul.innerHTML='';
        ls.forEach(function(l){
          var li=document.createElement('li');
          var a=document.createElement('span');a.textContent=l.title+(l.opt?' · '+l.opt:(l.item&&l.item.sel&&!l.id?' · size?':''));
          var b=document.createElement('span');b.textContent=money(l.price,fmt);
          li.appendChild(a);li.appendChild(b);ul.appendChild(li);
        });
      }

      var bar=root.querySelector('[data-hb-bar]');
      if(bar)bar.style.width=Math.min(hwN/min,1)*100+'%';
      var goal=root.querySelector('[data-hb-goal]');
      if(goal){
        if(unlocked)goal.innerHTML='<b>10% unlocked</b> — you save '+money(save,fmt)+', applied at checkout.';
        else if(hwN===0)goal.innerHTML='Pick <b>2 Halloween pieces</b> to unlock 10% off.';
        else goal.innerHTML='Add <b>1 more Halloween piece</b> to unlock 10% off.';
      }
      root.classList.toggle('is-unlocked',unlocked);

      var count=root.querySelector('[data-hb-count]');
      if(count)count.textContent=ls.length+(ls.length===1?' piece':' pieces');
      var was=root.querySelector('[data-hb-was]');
      if(was)was.textContent=save?money(total,fmt):'';
      var now=root.querySelector('[data-hb-now]');
      if(now)now.textContent=money(total-save,fmt);

      if(!busy&&btn){
        var need=anchor?2:1;
        btn.disabled=ls.length<need;
        if(ls.length<need)btn.textContent=anchor?'Pick a piece to add':'Pick a piece';
        else btn.textContent=(anchor?'Add all '+ls.length+' to cart':'Add '+ls.length+(ls.length===1?' piece':' pieces')+' to cart')+' — '+money(total-save,fmt);
      }
      return {ls:ls,unlocked:unlocked};
    }

    function showErr(msg,it){
      if(err){err.textContent=msg;err.hidden=false;}
      if(it&&it.sel){it.el.classList.add('is-missing');it.sel.focus();setTimeout(function(){it.el.classList.remove('is-missing');},1600);}
    }

    items.forEach(function(it){
      it.chk.addEventListener('change',function(){it.userToggled=true;if(err)err.hidden=true;render();});
      if(it.sel)it.sel.addEventListener('change',function(){
        it.touched=true;
        if(it.sel.getAttribute('data-sort')!=='size')it.styleTouched=true;
        if(!it.chk.checked)it.chk.checked=true;
        if(err)err.hidden=true;
        render();
      });
    });

    if(btn)btn.addEventListener('click',function(){
      var st=render();
      for(var i=0;i<st.ls.length;i++){
        var l=st.ls[i];
        if(!l.id){showErr('Choose a size for '+l.title+'.',l.item);return;}
        if(l.anchor&&l.available===false){showErr('This size is sold out: pick another one above.');return;}
      }
      busy=true;btn.disabled=true;btn.textContent='Adding…';
      if(err)err.hidden=true;
      fetch(rootUrl+'cart/add.js',{
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:st.ls.map(function(l){return {id:l.id,quantity:1};})})
      }).then(function(r){
        return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Could not add these pieces.');return j;});
      }).then(function(){
        if(!st.unlocked||!code)return null;
        return fetch(rootUrl+'discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(cartUrl),{credentials:'same-origin'}).catch(function(){});
      }).then(function(){
        window.location.href=cartUrl;
      }).catch(function(e){
        busy=false;showErr(e.message||'Something went wrong. Try again.');render();
      });
    });

    render();
  }

  function boot(){[].forEach.call(document.querySelectorAll('[data-hb]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
